"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistanceBetweenPointerEvents = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * In css pixels.
 */
function getDistanceBetweenPointerEvents(firstEvent, secondEvent) {
    const adjacent = firstEvent.clientX - secondEvent.clientX;
    const opposite = firstEvent.clientY - secondEvent.clientY;
    return rc_js_util_1._Math.hypot2(adjacent, opposite);
}
exports.getDistanceBetweenPointerEvents = getDistanceBetweenPointerEvents;
//# sourceMappingURL=get-distance-between-pointer-events.js.map